import React, { useEffect, useRef } from 'react';
import SimpleBar from 'simplebar-react';

import SimpleTable from '../global/tables/SimpleTable/SimpleTable';
import { useViewParents } from './ViewParents.hook';

import  '@/css/content/viewParents.scss'
import { simpleBarAutoScrollHandler } from  '@/helpers/SimpleBar';


const ViewParents = ({contentId, modalSelector} : {contentId:string, modalSelector?:string}) => {

    const simpleBarRef = useRef();
    const { table, nextPage, shouldFetchMore, isLoading } = useViewParents({contentId})

    function getTableHeight(): number {
        if(!table.rows.length) {
            return  88
        }

        return table.rows.length >= 6 ? 510 : table.rows.length * 70 + 15
    }

    function getModalHeight() {
        return getTableHeight() + 135
    }

    useEffect(() => {

        const modal: HTMLDivElement = document.querySelector(modalSelector);
        
        if(modal) {
            modal.style.height = `${getModalHeight()}px`;
        }
        
    },[table.rows.length])



    return (
        <div className={`parent-content-table-wrapper`}>
            <SimpleBar
                className='parent-content-table-wrapper' 
                style={{ 
                    border: table.rows.length >= 5 ? '1px solid #e3e3e3' : '',
                    height: getTableHeight(),
                }} 
                scrollableNodeProps={{ 
                    ref: simpleBarRef, 
                    onScroll: (e: React.UIEvent<HTMLElement>) => simpleBarAutoScrollHandler(e, shouldFetchMore(), nextPage)
                }}>
                    <SimpleTable 
                        simpleTableContent={table} 
                        isInfiniteScroll={false}
                        getMoreContent={nextPage}
                        isLoading={false}
                        noDataMessage={isLoading ? 'fetching parent items' : 'no parent items found'}
                    />
            </SimpleBar>
        </div>
    )
}

export default ViewParents;